import {MessarioTemplatesAccess} from '@lib/messarioTemplates/types';

export const MESSARIO_TEMPLATES_ACCESS_KEY_PREFIX = 'messario_templates_access:';

function storageKey(externalUserId: string) {
  return `${MESSARIO_TEMPLATES_ACCESS_KEY_PREFIX}${externalUserId}`;
}

export function saveMessarioTemplatesAccess(
  externalUserId: string,
  access: MessarioTemplatesAccess,
  storage: Storage = window.sessionStorage
) {
  if(!externalUserId || !access.token || !access.exp) {
    return;
  }

  storage.setItem(storageKey(externalUserId), JSON.stringify(access));
}

export function clearMessarioTemplatesAccess(
  externalUserId: string,
  storage: Storage = window.sessionStorage
) {
  storage.removeItem(storageKey(externalUserId));
}

export function getMessarioTemplatesAccess(
  externalUserId: string,
  storage: Storage = window.sessionStorage,
  nowSeconds = Math.floor(Date.now() / 1000)
): MessarioTemplatesAccess | undefined {
  const value = storage.getItem(storageKey(externalUserId));
  if(!value) {
    return undefined;
  }

  try {
    const access = JSON.parse(value) as MessarioTemplatesAccess;
    if(typeof access.token !== 'string' || !access.token || typeof access.exp !== 'number') {
      clearMessarioTemplatesAccess(externalUserId, storage);
      return undefined;
    }

    if(access.exp <= nowSeconds) {
      clearMessarioTemplatesAccess(externalUserId, storage);
      return undefined;
    }

    return access;
  } catch(err) {
    clearMessarioTemplatesAccess(externalUserId, storage);
    return undefined;
  }
}

export function listMessarioTemplatesAccessUserIds(
  storage: Storage = window.sessionStorage,
  nowSeconds = Math.floor(Date.now() / 1000)
): string[] {
  const userIds: string[] = [];
  for(let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if(!key?.startsWith(MESSARIO_TEMPLATES_ACCESS_KEY_PREFIX)) {
      continue;
    }

    const externalUserId = key.slice(MESSARIO_TEMPLATES_ACCESS_KEY_PREFIX.length);
    if(!externalUserId) {
      continue;
    }

    if(getMessarioTemplatesAccess(externalUserId, storage, nowSeconds)) {
      userIds.push(externalUserId);
    }
  }

  return userIds;
}

export function hasMessarioTemplatesAccessForUser(
  externalUserId: string,
  storage: Storage = window.sessionStorage,
  nowSeconds = Math.floor(Date.now() / 1000)
): boolean {
  return !!getMessarioTemplatesAccess(externalUserId, storage, nowSeconds);
}
